module.exports = __webpack_public_path__ + "img/audio.786853ed.png";